// 引入axios（axios进行二次封装）
import request from '@/utils/request'

// 新增系统用户
export function userSave(data) {
  return request({
    url: '/system/api/admin/user/save',
    method: 'post',
    data
  })
}

// 用户分页列表
export function userList(data) {
  return request({
    url: '/system/api/admin/user/list',
    method: 'get',
    params: data
  })
}

// 用户分页列表删除
export function userDelete(data) {
  return request({
    url: '/system/api/admin/user/delete',
    method: 'get',
    params: data
  })
}

// 用户详情
export function userInfo(data) {
  return request({
    url: '/system/api/admin/user/info',
    method: 'get',
    params: data
  })
}

// 更新系统用户
export function userUpdate(data) {
  return request({
    url: '/system/api/admin/user/update',
    method: 'post',
    data
  })
}

// 用户角色列表
export function sysroleList(data) {
  return request({
    url: '/system/api/admin/sysrole/list',
    method: 'get',
    params: data
  })
}

// 用户角色删除
export function sysroleDelete(data) {
  return request({
    url: '/system/api/admin/sysrole/delete',
    method: 'get',
    params: data
  })
}

// 上传文件
export function uploadFile(data) {
  return request({
    url: '/system/api/admin/upload/uploadFile',
    method: 'post',
    data
  })
}

// 新增菜单
export function sysmenuAdd(data) {
  return request({
    url: '/system/api/admin/sysmenu/add',
    method: 'post',
    data
  })
}

// 菜单缓存树
export function sysmenuTree() {
  return request({
    url: '/system/api/admin/sysmenu/cache/tree',
    method: 'get'
  })
}

// 菜单列表
export function sysmenuList(data) {
  return request({
    url: '/system/api/admin/sysmenu/list',
    method: 'get',
    params: data
  })
}

// 删除菜单
export function sysmenuDelete(id) {
  return request({
    url: '/system/api/admin/sysmenu/delete/' + id,
    method: 'post'
  })
}

// 编辑菜单
export function sysmenuUpdate(data) {
  return request({
    url: '/system/api/admin/sysmenu/update',
    method: 'post',
    data
  })
}

// 修改菜单显示状态
export function updateShowStatus(id) {
  return request({
    url: '/system/api/admin/sysmenu/updateShowStatus/' + id,
    method: 'post'
  })
}

// 新增身份
export function sysroleSave(data) {
  return request({
    url: '/system/api/admin/sysrole/save',
    method: 'post',
    data
  })
}

// 修改身份
export function sysroleUpdate(data) {
  return request({
    url: '/system/api/admin/sysrole/update',
    method: 'post',
    data
  })
}

// 日志分页
export function logList(data) {
  return request({
    url: '/system/api/admin/log/list',
    method: 'get',
    params: data
  })
}

// 导出系统日志
export function exportLog(data) {
  return request({
    url: '/system/api/admin/export/log',
    method: 'get',
    params: data
  })
}

// 租户管理分页列表
export function tenantList(data) {
  return request({
    url: '/system/api/admin/tenant/list',
    method: 'get',
    params: data
  })
}

// 租户管理添加
export function tenantAdd(data) {
  return request({
    url: '/system/api/admin/tenant/add',
    method: 'post',
    data
  })
}

// 租户管理编辑
export function tenantEdit(data) {
  return request({
    url: '/system/api/admin/tenant/edit',
    method: 'post',
    data
  })
}

// 租户管理删除
export function tenantDelete(data) {
  return request({
    url: '/system/api/admin/tenant/delete',
    method: 'post',
    data
  })
}

// 租户管理修改状态
export function tenantStatus(data) {
  return request({
    url: '/system/api/admin/tenant/status',
    method: 'post',
    data
  })
}

// 获取所有厂商
export function tenantListIdName(data) {
  return request({
    url: '/system/api/admin/tenant/listIdName',
    method: 'get',
    params: data
  })
}

// 配置权限范围
export function sysmenutemplateUpdate(data) {
  return request({
    url: '/system/api/admin/sysmenutemplate/update',
    method: 'post',
    data
  })
}

// 获取权限范围
export function sysmenutemplateList(data) {
  return request({
    url: '/system/api/admin/sysmenutemplate/list',
    method: 'get',
    params: data
  })
}

// 获取菜单id
export function getIdByTenantType(data) {
  return request({
    url: '/system/api/admin/sysmenutemplate/getIdByTenantType',
    method: 'get',
    params: data
  })
}

// 修改密码
export function innerUpdatePwd(data) {
  return request({
    url: '/system/api/admin/innerUpdatePwd',
    method: 'post',
    data
  })
}

// 修改厂商App权限
export function updateUserClientAuth(data) {
  return request({
    url: '/system/api/admin/user/updateUserClientAuth',
    method: 'post',
    data
  })
}
